/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';
import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

import OfferSignatures from '../../../signatures/offerSignatures.json';
import { NEXT_PUBLIC_ENV_KEYS } from '@marriott/mi-offers-components';

const { SESSION_APP_DOMAIN_URL } = process.env;

function pageRenderer(props) {
  console.log('[MBE] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const mbeSpecificData = async () => {
  // Feature flag call for MBOP
  const featureFlags = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_MBOP, {
    target: TARGETS.APP.OFFERS_RENDERER,
  });

  // Feature flag call for logo automation
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.OFFERS_RENDERER,
  });

  return {
    operationSignatures: OfferSignatures,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    featureFlags: { featureFlags, featureFlagLogo },
  };
};
const postAEMModelOperations = async (
  context: any,
  parallelCallsResponse: any,
  interceptorResponse: any,
  model: any
) => {
  console.log('[mbeSpecificData] interceptorResponse -', interceptorResponse);
  console.log('[mbeSpecificData] model?.mbeData -', model?.mbeData);
  const { req } = context;
  const sessionID = req?.cookies?.sessionID ?? '';
  const { sessionData } = parallelCallsResponse;
  let ariesSearch: any = sessionData?.cacheData?.data?.AriesSearch;
  const hasDestination =
    ariesSearch?.searchCriteria?.address?.destination &&
    ariesSearch?.searchCriteria?.address?.destination !== '' &&
    ariesSearch?.searchCriteria?.address?.destination !== undefined;
  const hasClusterCode =
    ariesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !== '' &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !== undefined &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode?.toUpperCase() === 'CORP';

  const hasCorpCode =
    ariesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode !== '' &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode !== undefined &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode?.toUpperCase() === 'QRI';
  const hasRateCode =
    ariesSearch?.searchCriteria?.availabilityRequestVO?.rateCollectionsClusterCode &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.rateCollectionsClusterCode !== '' &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.rateCollectionsClusterCode !== undefined &&
    ariesSearch?.searchCriteria?.availabilityRequestVO?.rateCollectionsClusterCode?.toUpperCase() === 'QRI';

  const mbeClusterCode = !(hasDestination && hasClusterCode)
    ? model?.mbeData?.clusterCode
    : ariesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode;
  const mbeCorporateCode = !(hasDestination && hasCorpCode)
    ? model?.mbeData?.corporateCode
    : ariesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode;
  const mbeRateCollectionsClusterCode = !(hasDestination && hasRateCode)
    ? model?.mbeData?.corporateCode
    : ariesSearch?.searchCriteria?.availabilityRequestVO?.rateCollectionsClusterCode;
  const searchType = hasDestination ? 'InCity' : 'Keyword';
  // update sessionData utility server side
  const updateSessionObjfunc = async (ariesSearch: any = {}) => {
    try {
      const url = `${SESSION_APP_DOMAIN_URL}/phoenix-gateway/v1/updateSession`;
      const headers = {
        Cookie: `sessionID=${sessionID}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      };
      const payload = {
        AriesSearch: ariesSearch,
        remove: [],
      };
      await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          console.log(`[MBE] update session done:, ${data}`);
          return data?.status;
        });
    } catch (error) {
      console.log(`[MBE] update session API Failed:, ${error}`);
    }
  };
  const updateSessionData = async () => {
    ariesSearch = {
      ...ariesSearch,
      searchCriteria: {
        ...ariesSearch?.searchCriteria,
        searchType: searchType,
        availabilityRequestVO: {
          ...ariesSearch?.searchCriteria?.availabilityRequestVO,
          clusterCode: mbeClusterCode,
          corporateCode: mbeCorporateCode,
          rateCollectionsClusterCode: mbeRateCollectionsClusterCode,
          numRooms: 1,
          numGuestsPerRoom: 1,
          numAdultsPerRoom: 1,
          maxRate: 0,
          minRate: 0,
          defaultDateSearch: false,
          lengthOfStay: 1,
        },
        keywordSearchRequestVO: {
          keywords: '',
        },
      },
    };
    await updateSessionObjfunc(ariesSearch);
  };

  if (!hasDestination || !(hasCorpCode && hasClusterCode)) {
    await updateSessionData();
  }
  const items = model.cqItems?.root?.[':items']?.responsivegrid?.[':items'];
  Object.keys(items).forEach(key => {
    const component = items[key];
    if (component[':type'] === 'mi-aem-offers-spa/components/onoffcontainer') {
      const items2 = component?.[':items'];
      Object.keys(items2).forEach(key2 => {
        const component2 = items2[key2];
        if (component2[':type'] === 'mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform') {
          component2.numberOfSearchForms = 1;
          // component2.enableRedeemPoints = false;
          // component2.disableSpecialRates = true;
          // component2.disableRoomGuest = true;
        }
      });
    }
  });
  return model;
};
//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(
  mbeSpecificData,
  {},
  false,
  false,
  false,
  undefined,
  postAEMModelOperations
);
export default pageRenderer;
